module.exports = __webpack_public_path__ + "img/HFIG-600.a7d9fa5c.webp";